/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import Box, { BoxProps } from '../Box/Box';

const LayoutContentCenter = <T extends keyof JSX.IntrinsicElements>({
  sx,
  as = 'div' as T,
  children,
  ...boxProps
}: BoxProps<T>): React.ReactElement => (
  <Box
    as={as}
    className="LayoutContent-Center"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      /*
       * & > *:not(:last-child) is the better selector but seems
       * like its not supported on IE11.
       */
      '& > *': {
        marginBottom: '1',
      },
      '& > *:last-child': {
        marginBottom: '0',
      },
      ...(sx as any),
    }}
    {...boxProps}
  >
    {children}
  </Box>
);

export default LayoutContentCenter;
